export const projectActivityInitialState: any = {
  is_aware: {
    condition: 'is_aware',
    value: '',
  },
  is_informed: {
    condition: 'is_informed',
    value: '',
  },
  is_engaged: {
    condition: 'is_engaged',
    value: '',
  },
}

export const getMappedProjectActivityFilters = (state: any) => {
  const mappedFilters = [
    {
      condition: 'is_aware',
      value: state['is_aware'].value,
      component: state['is_aware'].value ? 'FilterByProject' : '',
      fieldName: 'project_activity',
      name: 'projects',
    },
    {
      condition: 'is_informed',
      value: state['is_informed'].value,
      component: state['is_informed'].value ? 'FilterByProject' : '',
      fieldName: 'project_activity',
      name: 'projects',
    },
    {
      condition: 'is_engaged',
      value: state['is_engaged'].value,
      component: state['is_engaged'].value ? 'FilterByProject' : '',
      fieldName: 'project_activity',
      name: 'projects',
    },
  ]

  return mappedFilters
}
export const isOptionEqualToValue = (
  option: { name: string },
  value: { name: string },
) => {
  return option.name === value.name
}

export const getEngagementText = (value: Condition) => {
  switch (value) {
    case 'is_aware':
      return 'aware'
    case 'is_informed':
      return 'informed'
    case 'is_engaged':
      return 'engaged'
  }
}

export const getPaddingValues = (value: Condition) => {
  switch (value) {
    case 'is_aware':
      return '68px'
    case 'is_informed':
      return '48px'
    case 'is_engaged':
      return '50px'
  }
}
